import { CollectionResponseDto } from '../dto/response/collection-response.dto';
import { CollectionSaveRequestDto } from '../dto/request/collection-save-request.dto';
import { CollectionUpdateRequestDto } from '../dto/request/collection-update-request.dto';
import { BaseLandscapeService } from '../../base-landscape.service';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class CollectionService extends BaseLandscapeService {
  public async fetchCollections(): Promise<CollectionResponseDto[]> {
    const response = await this.get<CollectionResponseDto[]>(`/collection`);
    return response.data;
  }

  public async fetchCollectionById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<CollectionResponseDto> {
    const response = await this.get<CollectionResponseDto>(
      `/collection/${id}`,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async saveCollection(
    saveRequest: CollectionSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<CollectionResponseDto> {
    const response = await this.post<CollectionResponseDto>(
      `/collection`,
      saveRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async updateCollection(
    updateRequest: CollectionUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<CollectionResponseDto> {
    const response = await this.put<CollectionResponseDto>(
      `/collection`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteCollection(existingId: string): Promise<void> {
    await this.delete<void>(`/collection/${existingId}`);
  }
}

const collectionService = new CollectionService();
export default collectionService;
